import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSessions } from '../lib/api';
import { History, ChevronRight, ArrowLeft, Target } from 'lucide-react';

export default function HistoryPage() {
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSessions();
  }, []);

  const loadSessions = async () => {
    try {
      const { data } = await getSessions();
      setSessions(data);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const getLabelColor = (label) => {
    const colors = {
      'KO': '#E61C24', 'Faible': '#E61C24', 'Passable': '#FFF200',
      'Prometteur': '#00AEEF', 'Convaincant': '#39FF14', 'Expert': '#39FF14'
    };
    return colors[label] || '#71717A';
  };

  const formatDate = (iso) => {
    if (!iso) return '-';
    const d = new Date(iso);
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="bg-[#121214] border-b-2 border-[#00AEEF]/30 p-4 flex items-center gap-3">
        <button data-testid="back-btn" onClick={() => navigate('/dashboard')} className="text-[#00AEEF] hover:text-[#33C3FF] transition-colors">
          <ArrowLeft size={24} />
        </button>
        <History className="text-[#00AEEF] drop-shadow-[0_0_6px_rgba(0,174,239,0.6)]" size={24} />
        <h1 className="font-heading text-2xl uppercase tracking-wider">Historique</h1>
      </div>

      <div className="max-w-md mx-auto p-4">
        {loading ? (
          <div className="text-center font-mono text-[#A1A1AA] animate-pulse py-8">LOADING...</div>
        ) : sessions.length === 0 ? (
          <div className="text-center py-12">
            <p className="font-mono text-[#71717A] text-lg">Aucune session</p>
            <button
              data-testid="play-now-btn"
              onClick={() => navigate('/dashboard')}
              className="mt-4 bg-[#E61C24] hover:bg-[#FF333B] text-white font-heading text-sm uppercase tracking-wider py-3 px-6 transition-all"
            >
              JOUER MAINTENANT
            </button>
          </div>
        ) : (
          <div className="space-y-2">
            {sessions.map((s) => (
              <button
                key={s.session_id}
                data-testid={`session-${s.session_id}`}
                onClick={() => s.status === 'completed' && navigate(`/feedback/${s.session_id}`)}
                className="w-full text-left bg-[#121214] border border-gray-800 hover:border-[#00AEEF]/50 p-3 transition-all group"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <Target size={14} className="text-[#E61C24]" />
                      <span className="font-heading text-sm uppercase text-white">{s.profile_name}</span>
                      <span className="font-mono text-xs px-2 py-0.5 border" style={{ color: getLabelColor(s.label), borderColor: getLabelColor(s.label) + '50' }}>
                        {s.label || s.status}
                      </span>
                    </div>
                    <div className="flex items-center gap-3 mt-1">
                      <span className="font-mono text-xs text-[#A1A1AA]">{formatDate(s.started_at)}</span>
                      {s.score_total != null && (
                        <span className="font-mono text-sm" style={{ color: getLabelColor(s.label) }}>
                          {s.score_total}/100
                        </span>
                      )}
                    </div>
                  </div>
                  <ChevronRight className="text-[#71717A] group-hover:text-[#00AEEF] transition-colors" size={18} />
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
